import api from './client';

export const login = (username, password) =>
  api.post('/api/auth/login', { username, password }).then(res => res.data);

export const verifyToken = () =>
  api.get('/api/auth/verify').then(res => res.data);

export const logout = () =>
  api.post('/api/auth/logout').then(res => res.data);

export const changePassword = (currentPassword, newPassword) =>
  api.post('/api/auth/change-password', { currentPassword, newPassword }).then(res => res.data);
